import styled from 'styled-components/macro';

export const Footer = styled.div`
  display: flex;
  background-color: #ffffff;
  align-items: start;
  align-self: stretch;
  flex-direction: row;
  justify-content: end;
  border-top: 1px solid #d8deeb;
  padding: 8px 12px 4px 12px;
`;
